'use strict'
import VueTheMask from 'vue-the-mask'

export default Vue => {
  return Vue.use(VueTheMask)
}
